import React, { useState } from 'react';

import img1 from '../../assets/images/layouts/about-01.png';
import img2 from '../../assets/images/layouts/about-02.png';
import img3 from '../../assets/images/layouts/about-03.png';
import img4 from '../../assets/images/layouts/about-04.png';
import img5 from '../../assets/images/layouts/about-05.png';
import Button from '../button/Button';

function About(props) {
    const [dataImg] = useState([
        { id: 1, img: img1, class: 'img1' },
        { id: 2, img: img2, class: 'img2' },
        { id: 3, img: img3, class: 'img3' },
        { id: 4, img: img4, class: 'img4' },
        { id: 5, img: img5, class: 'img5' },
    ]);

    const [dataBlock] = useState({
        subheading: 'About Us',
        heading: 'Smarter Trading with PipPlus Tech',
        desc1:
            'PipPlus Tech is a next-gen forex algo trading platform built for precision, automation, and speed. We simplify complex markets with AI-powered systems so you can trade confidently—anytime, anywhere.',
        desc2:
            'Our mission is to make algorithmic trading accessible, reliable, and profitable for every trader.',
    });

    return (
        <section className="about">
            <div className="shape"></div>
            <div className="container">
                <div className="row rev">
                    <div className="col-xl-6 col-md-12">
                        <div className="about__right">
                            <div className="images">
                                {dataImg.map((idx) => (
                                    <img
                                        key={idx.id}
                                        className={idx.class}
                                        src={idx.img}
                                        alt="pipplus"
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-md-12">
                        <div className="block-text">
                            <h6 className="sub-heading">
                                <span>{dataBlock.subheading}</span>
                            </h6>
                            <h3 className="heading">{dataBlock.heading}</h3>
                            <p className="mb-17">{dataBlock.desc1}</p>
                            <p className="mb-26">{dataBlock.desc2}</p>
                            <Button link="/about" title="More About Us" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;
